import {MODALITY} from '@domain/model/Account/Subscription/Subscription';

const TEXT = {
  MODAL_DAY_CTA: {id: 'account.frequency.date.cta'},
};

const FREQUENCY_INFO = {
  [MODALITY.MONTHLY]: {
    title: {
      id: 'account.frequency.date_title_monthly',
    },
    subtitle: {
      id: 'account.frequency.date_subtitle_monthly',
    },
  },
  [MODALITY.BIMONTHLY]: {
    title: {
      id: 'account.frequency.date_title_bimonthly',
    },
    subtitle: {
      id: 'account.frequency.date_subtitle_bimonthly',
    },
  },
  [MODALITY.QUARTERLY]: {
    title: {
      id: 'account.frequency.date_title_quarterly',
    },
    subtitle: {
      id: 'account.frequency.date_subtitle_quarterly',
    },
  },
};

export {FREQUENCY_INFO, TEXT};
